import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrDownloadAisV2InputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'ITR Download AIS v2', subtitle: 'Initiate download of Annual Information Statement (v2)' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'financial_year', label: 'Financial Year', icon: 'pi-calendar', placeholder: '2024-25', maxLength: 10, mono: true },
        ]}
        endpoint={{
            path: '/surepass/itr/download-ais-v2',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), financial_year: v.financial_year.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-download-ais-v2"
        submitLabel="Download AIS"
        successSummary="AIS download initiated"
        errorSummary="AIS download failed"
        confirmHeader="Confirm AIS download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR AIS v2 Download', icon: 'pi-download' }}
    />
);

export default ItrDownloadAisV2InputComponent;
